import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Merge Tailwind classes with conflict resolution. The canonical shadcn helper. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
